import { API_URL } from "../config/api";

export type ActivityType =
  | "page_view"
  | "code_generated"
  | "code_entered"
  | "add_opened"
  | "add_cancelled"
  | "qr_scan_started"
  | "qr_scan_success"
  | "qr_scan_failed"
  | "licence_lookup_opened"
  | "licence_lookup_success"
  | "licence_lookup_failed"
  | "pay_choice"
  | "import_opened"
  | "import_previewed"
  | "import_cancelled";

const VISITOR_KEY = "visitorId";

function newId(): string {
  // crypto.randomUUID n'existe qu'en HTTPS ou sur localhost.
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }

  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (
      Number(c) ^
      (Math.random() * 16) >> (Number(c) / 4)
    ).toString(16)
  );
}

function getVisitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_KEY);

    if (!id) {
      id = newId();
      localStorage.setItem(VISITOR_KEY, id);
    }

    return id;
  } catch {
    return newId();
  }
}

function getRegistrationCode(): string | undefined {
  try {
    return localStorage.getItem("registrationCode") ?? undefined;
  } catch {
    return undefined;
  }
}

// Journalisation "fire and forget" : ne doit jamais gêner l'inscription.
export function logActivity(
  type: ActivityType,
  details?: Record<string, unknown>
): void {
  try {
    fetch(`${API_URL}/activity`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        visitorId: getVisitorId(),
        registrationCode: getRegistrationCode(),
        type,
        path: window.location.pathname,
        details,
      }),
    }).catch(() => {});
  } catch {
    // ignoré volontairement
  }
}
